import React, { useState, useEffect } from "react";
import {
    FormGroup,
    Label,
    Row,
    Col
} from "reactstrap";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { useDispatch, useSelector } from "react-redux";

import {
    listarSucursales,
    setDatosNuevoCompromiso
} from "../../../redux/aCompromisos";

import {
    selectNuevoCompromiso
} from "../../../redux/selectors";

const DatosClienteSection = ({
    tipoIdentificacion,
    numeroIdentificacion,
    nombreCompleto,
    emailCliente,
    telefono,
    celular,
    errores,
    onNombreChange,
    onEmailChange,
    onTelefonoChange,
    onCelularChange
}) => {

    const dispatch = useDispatch();

    const nuevoCompromiso = useSelector(selectNuevoCompromiso);

    const [sucursalSeleccionada, setSucursalSeleccionada] = useState(nuevoCompromiso.sucursal || null);

    const [sucursalesCatalogo, setSucursalesCatalogo] = useState([]);

    const [sucursalesFiltradas, setSucursalesFiltradas] = useState([]);

    useEffect(() => {

        const cargarSucursales = async () => {

            try {

                const respuesta =
                    await dispatch(
                        listarSucursales()
                    );

                console.log("respuesta", respuesta);

                if (
                    respuesta
                ) {


                    setSucursalesCatalogo(
                        respuesta
                    );
                }

            } catch (e) {

            }
        };

        cargarSucursales();

    }, [dispatch]);

    const buscarSucursales = (event) => {

        const termino =
            event.query
                ? event.query
                    .trim()
                    .toLowerCase()
                : "";

        const resultados =
            sucursalesCatalogo.filter((item) => {

                const nombre =
                    item.nombreSucursal
                        ? item.nombreSucursal.toLowerCase()
                        : "";

                return nombre.includes(termino);
            });

        setSucursalesFiltradas(resultados);
    };


    return (
        <>
            <Row>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Tipo de identificación
                            <span className="text-danger">
                                {" "}*
                            </span>
                        </Label>

                        <InputText
                            value={tipoIdentificacion}
                            disabled
                            className="w-100"
                        />

                    </FormGroup>
                </Col>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Número de identificación
                            <span className="text-danger">
                                {" "}*
                            </span>
                        </Label>

                        <InputText
                            value={numeroIdentificacion}
                            disabled
                            className="w-100"
                        />

                    </FormGroup>
                </Col>

            </Row>

            <Row>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Nombre o Razón Social
                        </Label>

                        <InputText
                            value={nombreCompleto}
                            onChange={onNombreChange}
                            className={
                                "w-100 " +
                                (errores.nombreCompleto
                                    ? "p-invalid"
                                    : "")
                            }
                        />

                        {errores.nombreCompleto && (
                            <small className="text-danger">
                                {errores.nombreCompleto}
                            </small>
                        )}

                    </FormGroup>
                </Col>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Email
                        </Label>

                        <InputText
                            value={emailCliente}
                            onChange={onEmailChange}
                            className={
                                "w-100 " +
                                (errores.emailCliente
                                    ? "p-invalid"
                                    : "")
                            }
                        />

                        {errores.emailCliente && (
                            <small className="text-danger">
                                {errores.emailCliente}
                            </small>
                        )}

                    </FormGroup>
                </Col>

            </Row>

            <Row>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Teléfono
                        </Label>

                        <InputText
                            value={telefono}
                            onChange={onTelefonoChange}
                            className={
                                "w-100 " +
                                (errores.telefono
                                    ? "p-invalid"
                                    : "")
                            }
                        />

                        {errores.telefono && (
                            <small className="text-danger">
                                {errores.telefono}
                            </small>
                        )}

                    </FormGroup>
                </Col>

                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Celular
                        </Label>

                        <InputText
                            value={celular}
                            onChange={onCelularChange}
                            className={
                                "w-100 " +
                                (errores.celular
                                    ? "p-invalid"
                                    : "")
                            }
                        />

                        {errores.celular && (
                            <small className="text-danger">
                                {errores.celular}
                            </small>
                        )}

                    </FormGroup>
                </Col>

            </Row>
            <Row>
                <Col lg={6} md={6} sm={6} xs={12}>
                    <FormGroup>

                        <Label>
                            Sucursal
                        </Label>

                        <AutoComplete
                            value={sucursalSeleccionada}
                            suggestions={sucursalesFiltradas}
                            completeMethod={buscarSucursales}
                            onChange={(event) => {
                                const sucursal = event.value || null;

                                setSucursalSeleccionada(sucursal);

                                dispatch(
                                    setDatosNuevoCompromiso({
                                        sucursal: sucursal
                                    })
                                );
                            }}
                            field="nombreSucursal"
                            placeholder="Seleccione"
                            dropdown
                            className={
                                "w-100 " +
                                (errores.sucursal
                                    ? "p-invalid"
                                    : "")
                            }
                        />

                        {errores.sucursal && (
                            <small className="text-danger">
                                {errores.sucursal}
                            </small>
                        )}
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
};

export default DatosClienteSection;